/* DRIPLORE — Collection page description Read-more toggle (mobile only).
   Only the page-level description rte-formatter inside the collection
   heading section is targeted; product card titles are excluded by the
   product-card / results-list ancestor checks. Loaded from scripts.liquid
   only on collection templates.

   Why JS instead of pure CSS: rte-formatter renders raw collection HTML so
   we can't inject a <details>/checkbox without rewriting the block. JS keeps
   the toggle button out of the desktop DOM entirely. */
(function () {
  var MQ = '(max-width: 749px)';

  function findDescription(main) {
    var nodes = main.querySelectorAll('rte-formatter');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('product-card')) continue;
      if (el.closest('results-list')) continue;
      return el;
    }
    return null;
  }

  function init() {
    if (window.matchMedia && !window.matchMedia(MQ).matches) return;
    var main = document.querySelector('main[data-template="collection"]');
    if (!main) return;
    var desc = findDescription(main);
    if (!desc) return;
    if (desc.dataset.driploreReadmoreInit) return;
    desc.dataset.driploreReadmoreInit = '1';

    desc.classList.add('driplore-rte-clamp');

    requestAnimationFrame(function () {
      if (desc.scrollHeight <= desc.clientHeight + 4) {
        desc.classList.remove('driplore-rte-clamp');
        return;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'driplore-rte-readmore';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Read more';
      btn.addEventListener('click', function () {
        var expanded = desc.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? 'Show less' : 'Read more';
      });
      desc.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
